@if (!isUserActive()) {
  <a
    class="uppercase cursor-pointer"
    data-translation="reset.button.text"
    (click)="onResetShop($event)"
    (keydown.enter)="onResetShop($event)"
    (keydown.space)="onResetShop($event)"
  >
    {{ 'reset.button.text' | translate | hideTranslation }}
  </a>
}
